import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import subscriptionService from './subscriptionService'


const initialState = {
    isError: false,
    isSuccess: false,
    isLoading: false,
    redirectUrl: '',
    message: '',
}

export const createCheckoutSession = createAsyncThunk('subscription/createCheckoutSession', async (subscriptionData, thunkAPI) => {
    try {
        const token = thunkAPI.getState().auth.user.token
        return await subscriptionService.createCheckoutSession(subscriptionData, token)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        // console.log(error)
        return thunkAPI.rejectWithValue(message)
    }
})

export const createPortalSession = createAsyncThunk('subscription/createPortalSession', async (subscriptionData, thunkAPI) => {
    try {
        const token = thunkAPI.getState().auth.user.token
        return await subscriptionService.createPortalSession(subscriptionData, token)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        // console.log(error)
        return thunkAPI.rejectWithValue(message)
    }
})

export const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false
            state.isSuccess = false
            state.isError = false
            state.redirectUrl = ''
            state.message = ''
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createCheckoutSession.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createCheckoutSession.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.redirectUrl = action.payload.url
            })
            .addCase(createCheckoutSession.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(createPortalSession.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createPortalSession.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.redirectUrl = action.payload.url
            })
            .addCase(createPortalSession.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    },
})

export const { reset } = subscriptionSlice.actions
export default subscriptionSlice.reducer